// 宮崎通クイズ - 全100問
// 究極の宮崎通クイズ：あなたの地元愛を試す100の質問

export const quizData = [
  // セット1: 第1部 宮崎ソウルフード編 (Q1-10)
  {
    id: 1,
    question: '宮崎のソウルフード、チキン南蛮。タルタルソースをかけて提供するスタイルを確立した「元祖」として知られるお店は次のうちどれでしょう？',
    options: ['直ちゃん', '栄養軒', 'おぐら', 'ロンドン'],
    correctAnswer: 2,
    explanation: 'タルタルソースをかけるスタイルを確立したのは「おぐら」です。'
  },
  {
    id: 2,
    question: 'チキン南蛮のもう一つの元祖「直ちゃん」。こちらのチキン南蛮の最大の特徴は何でしょう？',
    options: ['タルタルソースの代わりにオーロラソースがかかっている', '鶏もも肉のみを使用している', 'タルタルソースがなく、甘酢ダレだけで味わう', 'カレー風味のスパイスが効いている'],
    correctAnswer: 2,
    explanation: '「直ちゃん」のチキン南蛮は、タルタルソースを使わず甘酢ダレだけで味わうのが特徴です。'
  },
  {
    id: 3,
    question: '「おぐら」と「直ちゃん」の創業者が修行した、チキン南蛮発祥のきっかけとなった延岡市にあった洋食店の名前は何でしょう？',
    options: ['パリ', 'ニューヨーク', 'ベルリン', 'ロンドン'],
    correctAnswer: 3,
    explanation: 'チキン南蛮は延岡市の洋食店「ロンドン」で生まれました。'
  },
  {
    id: 4,
    question: 'チキン南蛮が、修行先の洋食店「ロンドン」で生まれた際のきっかけは何だったでしょう？',
    options: ['海外からの賓客をもてなす特別料理', 'スタッフのための「まかない料理」', '料理コンテストへの出品作', 'クリスマス限定メニュー'],
    correctAnswer: 1,
    explanation: 'チキン南蛮は元々、スタッフのまかない料理として生まれました。'
  },
  {
    id: 5,
    question: '「おぐら」が創業したのは昭和31年ですが、チキン南蛮がメニューに登場したのはいつでしょう？',
    options: ['昭和31年（創業当初から）', '昭和34年', '昭和40年', '昭和45年'],
    correctAnswer: 1,
    explanation: 'チキン南蛮は昭和34年にメニューに登場しました。'
  },
  {
    id: 6,
    question: '「おぐら」のチキン南蛮は、もともと余りがちだったある部位を有効活用するために考案されました。その部位とはどこでしょう？',
    options: ['鶏もも肉', '鶏むね肉', 'ささみ', '手羽先'],
    correctAnswer: 1,
    explanation: '余りがちだった鶏むね肉を有効活用するために考案されました。'
  },
  {
    id: 7,
    question: '「おぐら」の店の入り口やロゴマークに描かれている、創業者の甲斐義光さんをモデルにしたキャラクターが持っているものは何でしょう？',
    options: ['フライパン', 'フォークとナイフ', 'コック帽', 'トーテムポール'],
    correctAnswer: 3,
    explanation: 'トーテムポールを持ったキャラクターが特徴的です。'
  },
  {
    id: 8,
    question: '今や全国的に人気の巻き寿司「レタス巻き」は宮崎発祥です。このレタス巻きを考案した寿司店はどこでしょう？',
    options: ['すし処 重乃井', '寿司虎', '一平寿司', '鮨 おおしょう'],
    correctAnswer: 2,
    explanation: 'レタス巻きは宮崎の「一平寿司」で考案されました。'
  },
  {
    id: 9,
    question: '「一平寿司」の初代店主がレタス巻きを考案したきっかけは、ある有名人の友人のためでした。その友人とは誰でしょう？',
    options: ['長嶋茂雄', '平尾昌晃', '坂本九', '石原裕次郎'],
    correctAnswer: 1,
    explanation: '歌手の平尾昌晃さんの友人のために考案されました。'
  },
  {
    id: 10,
    question: 'レタス巻きの主な具材の組み合わせとして正しいものはどれでしょう？',
    options: ['レタス、マグロ、マヨネーズ', 'レタス、エビ、マヨネーズ', 'レタス、カニカマ、わさび', 'レタス、アボカド、醤油'],
    correctAnswer: 1,
    explanation: 'レタス、エビ、マヨネーズの組み合わせが定番です。'
  },

  // セット2: 第1部 宮崎ソウルフード編 (Q11-20)
  {
    id: 11,
    question: '延岡発祥のソウルフード「辛麺」。その人気を全国区にした代表的なお店はどこでしょう？',
    options: ['ラーメンマン', '桝元', '栄養軒', 'きむら'],
    correctAnswer: 1,
    explanation: '辛麺の人気店といえば「桝元」です。'
  },
  {
    id: 12,
    question: '辛麺「桝元」で使われる、そば粉と小麦粉が主原料の独特な食感の麺の通称は何でしょう？',
    options: ['しらたき麺', '冷麺', 'こんにゃく麺', '春雨麺'],
    correctAnswer: 2,
    explanation: 'こんにゃくのような独特の食感から「こんにゃく麺」と呼ばれています。'
  },
  {
    id: 13,
    question: '辛麺「桝元」のスープを構成する基本的な具材に含まれないものはどれでしょう？',
    options: ['ニンニク', 'ひき肉', 'メンマ', '溶き卵'],
    correctAnswer: 2,
    explanation: 'メンマは辛麺の基本的な具材には含まれません。'
  },
  {
    id: 14,
    question: '辛麺「桝元」の辛さは0辛から選べますが、メニューに記載されている最も辛いレベル（スーパー激辛）は辛さ何倍でしょう？',
    options: ['15倍', '25倍', '50倍', '100倍'],
    correctAnswer: 1,
    explanation: 'スーパー激辛は25倍の辛さです。'
  },
  {
    id: 15,
    question: '辛麺「桝元」で、辛いものが苦手な人向けに豆乳ベースで作られたメニューの名前は何でしょう？',
    options: ['白い辛麺', 'マイルド辛麺', '豆乳辛麺', 'ゼロ辛麺'],
    correctAnswer: 0,
    explanation: '豆乳ベースの「白い辛麺」があります。'
  },
  {
    id: 16,
    question: '辛麺「桝元」で、ラーメンと並んで多くの客が注文する、トロトロに煮込んだ豚なんこつをポン酢でいただく名物サイドメニューは何でしょう？',
    options: ['豚足', 'なんこつ', 'チャーシュー', '角煮'],
    correctAnswer: 1,
    explanation: 'トロトロの「なんこつ」が名物サイドメニューです。'
  },
  {
    id: 17,
    question: '宮崎の繁華街「ニシタチ」で飲んだ後の「シメ」として、ラーメン以上に定番となっている食べ物は何でしょう？',
    options: ['雑炊', 'お茶漬け', '釜揚げうどん', '肉巻きおにぎり'],
    correctAnswer: 2,
    explanation: '宮崎では釜揚げうどんがシメの定番です。'
  },
  {
    id: 18,
    question: '宮崎の釜揚げうどん御三家の一つで、有名スポーツ選手も御用達として知られ、いりこ出汁を使わないのが特徴のお店はどこでしょう？',
    options: ['戸隠', '織田薪', '重乃井', '岩見'],
    correctAnswer: 2,
    explanation: 'いりこ出汁を使わない「重乃井」が特徴的です。'
  },
  {
    id: 19,
    question: '宮崎の釜揚げうどん御三家の一つで、繁華街の中心に位置し、飲んだ後でも食べやすい「細麺」が特徴のお店はどこでしょう？',
    options: ['戸隠', '織田薪', '重乃井', '大八'],
    correctAnswer: 0,
    explanation: '細麺が特徴の「戸隠」です。'
  },
  {
    id: 20,
    question: '宮崎の釜揚げうどん御三家の一つ「織田薪」。ここの釜揚げうどんのつけ汁に入っている揚げ玉（天かす）は、どのような形をしているのが特徴的でしょう？',
    options: ['小さな丸い粒状', '大きな塊状', 'エビの形', '細長い形状'],
    correctAnswer: 3,
    explanation: '「織田薪」は細長い形状の揚げ玉が特徴です。'
  },

  // セット3: 第1部 宮崎ソウルフード編 (Q21-30)
  {
    id: 21,
    question: '釜揚げうどんを食べ終わった後、残ったつけ汁にうどんの茹で汁を入れて飲むのが宮崎流ですが、この茹で汁のことを何と呼ぶでしょう？',
    options: ['割り下', 'スープ割り', '釜湯', '蕎麦湯'],
    correctAnswer: 2,
    explanation: 'うどんの茹で汁は「釜湯」と呼ばれます。'
  },
  {
    id: 22,
    question: '昭和39年創業の宮崎ラーメンの老舗「栄養軒」。麺大盛りのことを指す、この店独特の呼び方は何でしょう？',
    options: ['麺マシ', '麺デラ', '大麺', '替玉スペシャル'],
    correctAnswer: 1,
    explanation: '大盛りは「麺デラ」と呼ばれます。'
  },
  {
    id: 23,
    question: '宮崎ラーメンの老舗「栄養軒」のチャーシューメン（肉多め）のことを指す、独特の呼び方は何でしょう？',
    options: ['肉デラ', 'チャーシューマシマシ', '肉スペシャル', 'デラックスラーメン'],
    correctAnswer: 0,
    explanation: 'チャーシュー多めは「肉デラ」です。'
  },
  {
    id: 24,
    question: '宮崎ラーメンの元祖的存在である「栄養軒」の創業者が、引退後に再び立ち上げたお店で、本来の栄養軒の味を受け継いでいると言われるお店はどこでしょう？',
    options: ['きむら', '宝来', 'さといも', 'ラーメンマン'],
    correctAnswer: 2,
    explanation: '創業者の味を受け継ぐのは「さといも」です。'
  },
  {
    id: 25,
    question: '宮崎ラーメンの特徴として、多くの店で見られるトッピングは何でしょう？',
    options: ['きくらげ', '紅しょうが', 'もやし', '高菜'],
    correctAnswer: 2,
    explanation: '宮崎ラーメンには「もやし」がトッピングされることが多いです。'
  },
  {
    id: 26,
    question: '宮崎市にある人気ラーメン店「拉麺男（ラーメンマン）」。大量の豚骨を継ぎ足しながら作る、その濃厚な「ドロ系」スープの製法を何と呼ぶでしょう？',
    options: ['呼び戻し', '追い炊き', '熟成重ね', '濃厚一番搾り'],
    correctAnswer: 0,
    explanation: '継ぎ足し製法は「呼び戻し」と呼ばれます。'
  },
  {
    id: 27,
    question: '居酒屋のまかない料理から生まれた宮崎名物「肉巻きおにぎり」。その発祥のお店（旧名：とりあえず本舗）は何でしょう？',
    options: ['雑食堂', 'にくまき本舗', '丸万', '嵐坊'],
    correctAnswer: 1,
    explanation: '発祥は「にくまき本舗」（旧名：とりあえず本舗）です。'
  },
  {
    id: 28,
    question: '肉巻きおにぎりは元々三角形でしたが、食べやすさを追求して現在の形になりました。現在の主流の形は何でしょう？',
    options: ['丸型', '四角形', '俵型', 'スティック状'],
    correctAnswer: 2,
    explanation: '現在は食べやすい「俵型」が主流です。'
  },
  {
    id: 29,
    question: '魚のすり身に野菜などを混ぜ、パン粉をつけて揚げた宮崎のソウルフード「ぎょろっけ」。この名前の由来は何と何を組み合わせたものでしょう？',
    options: ['魚（ぎょ）＋ロケット', '魚（ぎょ）＋コロッケ', '漁師（ぎょし）＋ロック', '魚肉（ぎょにく）＋OK'],
    correctAnswer: 1,
    explanation: '「魚（ぎょ）」と「コロッケ」を組み合わせた名前です。'
  },
  {
    id: 30,
    question: '「ぎょろっけ」の味付けの特徴として、多くの製品に共通して加えられているスパイスは何でしょう？',
    options: ['カレー粉', '山椒', '唐辛子', 'わさび'],
    correctAnswer: 2,
    explanation: '「ぎょろっけ」には唐辛子が加えられているものが多いです。'
  },

  // セット4: 第2部 定番お土産・スイーツ編 (Q31-40)
  {
    id: 31,
    question: '宮崎の有名店「お菓子の日高」の看板商品で、中にイチゴ、栗、クリームチーズが入った巨大な大福の名前は何でしょう？',
    options: ['びっくり大福', '宮崎てんこもり大福', 'なんじゃこら大福', 'ひなた大福'],
    correctAnswer: 2,
    explanation: 'インパクト抜群の「なんじゃこら大福」です。'
  },
  {
    id: 32,
    question: '「なんじゃこら大福」の中に入っているフルーツは何でしょう？',
    options: ['キンカン', 'マンゴー', 'イチゴ', '日向夏'],
    correctAnswer: 2,
    explanation: '「なんじゃこら大福」にはイチゴが入っています。'
  },
  {
    id: 33,
    question: '「なんじゃこら大福」の中に入っている栗の他に、もう一つ特徴的な具材は何でしょう？',
    options: ['生クリーム', 'カスタードクリーム', 'クリームチーズ', '白あん'],
    correctAnswer: 2,
    explanation: 'クリームチーズが入っているのが特徴です。'
  },
  {
    id: 34,
    question: '「なんじゃこら大福」が誕生したきっかけとなった、お菓子の日高が昭和62年に開催したイベントは何でしょう？',
    options: ['宮崎お菓子コンテスト', '大福まつり', 'ホワイトデーフェア', '創業記念祭'],
    correctAnswer: 1,
    explanation: '「大福まつり」がきっかけで誕生しました。'
  },
  {
    id: 35,
    question: '「なんじゃこら大福」というユニークな名前の由来は何でしょう？',
    options: ['社内公募で決まった', '地元の伝説にちなんで', '試食した友人の第一声', '社長のひらめき'],
    correctAnswer: 2,
    explanation: '試食した友人が「なんじゃこら！」と言ったのが由来です。'
  },
  {
    id: 36,
    question: '「なんじゃこら大福」の姉妹品で、同じくイチゴ、栗、クリームチーズが入った巨大なシュークリームの名前は何でしょう？',
    options: ['なんじゃこらシュー', 'びっくりシュー', '宮崎シュー', '日高スペシャル'],
    correctAnswer: 0,
    explanation: '「なんじゃこらシュー」という姉妹品があります。'
  },
  {
    id: 37,
    question: '「なんじゃこらシュー」の中に入っているクリームは、カスタードクリームと何でしょう？',
    options: ['生クリーム', 'チョコクリーム', '小倉生クリーム', '抹茶クリーム'],
    correctAnswer: 2,
    explanation: 'カスタードクリームと小倉生クリームが入っています。'
  },
  {
    id: 38,
    question: '宮崎の定番土産「チーズ饅頭」。小林市に本店があり「元祖」を名乗るお店の一つで、スコーンのような生地が特徴なのはどこでしょう？',
    options: ['わらべ', '南国屋今門', '風月堂', '味のくらや'],
    correctAnswer: 2,
    explanation: 'スコーンのような生地が特徴の「風月堂」です。'
  },
  {
    id: 39,
    question: '「元祖チーズ饅頭」で知られる「風月堂」が運営する、宮崎市内で人気の洋菓子店の名前は何でしょう？',
    options: ['プティ・フール', 'アンオー', 'スイートアリス', 'コンクワート'],
    correctAnswer: 2,
    explanation: '風月堂は「スイートアリス」も運営しています。'
  },
  {
    id: 40,
    question: '「菓子処 わらべ」や「南国屋今門」も「元祖」を名乗っており、宮崎のチーズ饅頭には複数の元祖が存在します。さて、「菓子処 わらべ」が創業したのはいつでしょう？',
    options: ['1962年', '1975年', '1984年', '1990年'],
    correctAnswer: 2,
    explanation: '「菓子処 わらべ」は1984年創業です。'
  },

  // セット5: 第2部 定番お土産・スイーツ編 + 第3部 地元企業・ランドマーク編 (Q41-50)
  {
    id: 41,
    question: '宮崎市内の若草通りなどで行列ができる人気の饅頭店「蜂楽饅頭」。蜂蜜を練り込んだ生地が特徴ですが、定番のあんこは「黒あん」と何でしょう？',
    options: ['抹茶あん', '白あん', '芋あん', 'カスタード'],
    correctAnswer: 1,
    explanation: '「黒あん」と「白あん」の2種類が定番です。'
  },
  {
    id: 42,
    question: '「蜂楽饅頭」の「黒あん」の原料となっている豆の種類は何でしょう？',
    options: ['大納言', '黒豆', '小豆', 'ささげ'],
    correctAnswer: 2,
    explanation: '黒あんは小豆を使用しています。'
  },
  {
    id: 43,
    question: '「蜂楽饅頭」の「白あん」の原料となっている豆の種類は何でしょう？',
    options: ['白インゲン豆', '大手亡豆', 'ひよこ豆', '大豆'],
    correctAnswer: 1,
    explanation: '白あんは大手亡豆を使用しています。'
  },
  {
    id: 44,
    question: '「蜂楽饅頭」で夏期限定で販売され、饅頭と並ぶほどの人気を誇るメニューは何でしょう？',
    options: ['ソフトクリーム', '冷やしぜんざい', 'かき氷', 'フルーツパフェ'],
    correctAnswer: 2,
    explanation: '夏期限定の「かき氷」が大人気です。'
  },
  {
    id: 45,
    question: '「蜂楽饅頭」の夏期限定かき氷の中で、鮮やかな青色をした蜂蜜ミルク味の一番人気メニューの名前は何でしょう？',
    options: ['ブルーハワイ', 'ミルクブルー', 'スカイミント', 'コバルトアイス'],
    correctAnswer: 3,
    explanation: '鮮やかな青色の「コバルトアイス」が一番人気です。'
  },
  {
    id: 46,
    question: '宮崎空港や宮崎駅などでも実演販売を行っている「味のくらや」の名物で、さつまいもと餅を搗き混ぜて作る郷土菓子は何でしょう？',
    options: ['ねりくり', 'あくまき', 'からいも団子', 'ふくれ菓子'],
    correctAnswer: 2,
    explanation: '「からいも団子」が名物です。'
  },
  {
    id: 47,
    question: '「味のくらや」の「からいも団子」に使われている「からいも」とは、宮崎の方言で何を指すでしょう？',
    options: ['唐辛子', 'じゃがいも', 'さつまいも', '里芋'],
    correctAnswer: 2,
    explanation: '宮崎では「からいも」はさつまいもを指します。'
  },
  {
    id: 48,
    question: '九州を代表するホームセンター「ハンズマン」。その創業の地は宮崎県のどこでしょう？',
    options: ['宮崎市', '延岡市', '都城市', '日南市'],
    correctAnswer: 2,
    explanation: 'ハンズマンは都城市で創業しました。'
  },
  {
    id: 49,
    question: '「ハンズマン」の前身となった会社は、もともと何を扱う専門商社だったでしょう？',
    options: ['電化製品', '農業資材', '硝子・建材', '事務用品'],
    correctAnswer: 2,
    explanation: '元々は硝子・建材を扱う専門商社でした。'
  },
  {
    id: 50,
    question: 'ホームセンターとしての「ハンズマン」1号店（吉尾店）がオープンしたのはいつでしょう？',
    options: ['1964年', '1975年', '1986年', '1995年'],
    correctAnswer: 2,
    explanation: 'ハンズマン1号店は1986年にオープンしました。'
  },

  // セット6: 第3部 地元企業・ランドマーク編 + 第4部 うまいもん編 (Q51-60)
  {
    id: 51,
    question: '2023年、ハンズマンは九州地方以外で初となる店舗をオープンしました。それはどこでしょう？',
    options: ['東京都', '大阪府', '愛知県', '広島県'],
    correctAnswer: 1,
    explanation: '2023年に大阪府に初出店しました。'
  },
  {
    id: 52,
    question: '宮崎に本社を置く航空会社「ソラシドエア」。2015年までの旧社名は何だったでしょう？',
    options: ['パンアジア航空', 'スカイネットアジア航空', '九州国際航空', '宮崎エアライン'],
    correctAnswer: 1,
    explanation: '旧社名は「スカイネットアジア航空」でした。'
  },
  {
    id: 53,
    question: '「ソラシドエア」が宮崎-羽田線の運航を開始し、本格的に「宮崎の翼」としてスタートしたのはいつでしょう？',
    options: ['1997年', '2002年', '2005年', '2011年'],
    correctAnswer: 1,
    explanation: '2002年に宮崎-羽田線の運航を開始しました。'
  },
  {
    id: 54,
    question: '「ソラシドエア」というブランド名が導入されたのは2011年ですが、正式に株式会社ソラシドエアに社名変更されたのはいつでしょう？',
    options: ['2011年', '2013年', '2015年', '2018年'],
    correctAnswer: 2,
    explanation: '正式な社名変更は2015年です。'
  },
  {
    id: 55,
    question: '宮崎県の路線バスなどを運営する「宮崎交通」。2016年3月末まで使用されていた独自のIC カード乗車券の名前は何でしょう？',
    options: ['宮交カード', 'ひまわりカード', '宮交バスカ', 'フェニックスカード'],
    correctAnswer: 2,
    explanation: '「宮交バスカ」という独自のICカードがありました。'
  },
  {
    id: 56,
    question: '現在、宮崎交通のバスで利用できる、全国相互利用可能な交通系ICカードは何でしょう？',
    options: ['Suica', 'ICOCA', 'SUGOCA', 'nimoca'],
    correctAnswer: 3,
    explanation: '現在は「nimoca」が利用できます。'
  },
  {
    id: 57,
    question: '宮崎交通が運営する、バスターミナルを併設した宮崎市南部の大型商業施設の名前は何でしょう？',
    options: ['イオンモール宮崎', 'アミュプラザみやざき', '宮交シティ', 'ボンベルタ橘'],
    correctAnswer: 2,
    explanation: '「宮交シティ」という大型商業施設を運営しています。'
  },
  {
    id: 58,
    question: '宮崎市の中心市街地にある百貨店「宮崎山形屋」。そのルーツである鹿児島市の「山形屋」が創業したのはいつでしょう？',
    options: ['1751年（宝暦元年）', '1868年（明治元年）', '1916年（大正5年）', '1956年（昭和31年）'],
    correctAnswer: 0,
    explanation: '山形屋は1751年（宝暦元年）に創業しました。'
  },
  {
    id: 59,
    question: '宮崎山形屋が2006年に新館をオープンした際、宮崎初出店として話題になったコーヒーチェーン店はどこでしょう？',
    options: ['タリーズコーヒー', 'ドトールコーヒーショップ', 'スターバックスコーヒー', 'コメダ珈琲店'],
    correctAnswer: 2,
    explanation: 'スターバックスコーヒーが宮崎初出店しました。'
  },
  {
    id: 60,
    question: '持ち帰り餃子の専門店として都城市で創業し、県内外で絶大な人気を誇るお店はどこでしょう？',
    options: ['餃子の馬渡', 'たかなべギョーザ', 'ぎょうざの丸岡', '黒兵衛'],
    correctAnswer: 2,
    explanation: '「ぎょうざの丸岡」が都城市で創業しました。'
  },

  // セット7: 第3部 地元企業・ランドマーク編 + 第4部 うまいもん編 (Q61-70)
  {
    id: 61,
    question: '「ぎょうざの丸岡」の餃子の特徴として、適切でないものはどれでしょう？',
    options: ['冷凍せず生のまま冷蔵で届けられる', 'キャベツがたっぷりでシャキシャキしている', '焼くとパリッ、茹でるとツルンとなる薄皮', 'ニンニクを一切使用していない'],
    correctAnswer: 3,
    explanation: 'ニンニクは使用されています。適切でないのはDです。'
  },
  {
    id: 62,
    question: '「ぎょうざの丸岡」の餃子の餡のレシピは、ある人物しか知らない秘伝とされています。その人物とは誰でしょう？',
    options: ['創業者', '社長', '工場長', '開発部長'],
    correctAnswer: 1,
    explanation: '餡のレシピは社長しか知らない秘伝です。'
  },
  {
    id: 63,
    question: '都城市に本社を置く霧島酒造の代表的な芋焼酎「黒霧島」。その麹の種類は何でしょう？',
    options: ['白麹', '黒麹', '黄麹', '麦麹'],
    correctAnswer: 1,
    explanation: '「黒霧島」は黒麹を使用しています。'
  },
  {
    id: 64,
    question: '霧島酒造の「赤霧島」の原料として使われている、紫芋の品種名は何でしょう？',
    options: ['コガネセンガン', 'ジョイホワイト', 'ムラサキマサリ', 'アヤムラサキ'],
    correctAnswer: 2,
    explanation: '「赤霧島」には紫芋の「ムラサキマサリ」が使われています。'
  },
  {
    id: 65,
    question: '霧島酒造の「茜霧島」の原料として使われている、オレンジ色のさつまいもの品種名は何でしょう？',
    options: ['タマアカネ', 'ベニハルカ', '安納芋', 'シルクスイート'],
    correctAnswer: 0,
    explanation: '「茜霧島」にはオレンジ色の「タマアカネ」が使われています。'
  },
  {
    id: 66,
    question: '霧島酒造の「茜霧島」に使われている酵母は、ある植物の花から採取された珍しいものです。その植物とは何でしょう？',
    options: ['ハイビスカス', '桜', '観賞用サツマイモ「花らんまん」', 'ブーゲンビリア'],
    correctAnswer: 2,
    explanation: '観賞用サツマイモ「花らんまん」の花から採取した酵母が使われています。'
  },
  {
    id: 67,
    question: '世界で初めて「そば焼酎」を開発した、宮崎市に本社を置く酒造メーカーはどこでしょう？',
    options: ['霧島酒造', '神楽酒造', '雲海酒造', '井上酒造'],
    correctAnswer: 2,
    explanation: '世界初のそば焼酎を開発したのは「雲海酒造」です。'
  },
  {
    id: 68,
    question: '雲海酒造が製造する人気の芋焼酎「木挽BLUE」。その醸造に使われている、独自に開発した酵母の名前は何でしょう？',
    options: ['宮崎酵母', '綾の湧水酵母', '日向灘黒潮酵母', '五ヶ瀬の恵み酵母'],
    correctAnswer: 2,
    explanation: '「日向灘黒潮酵母」という独自開発の酵母を使用しています。'
  },
  {
    id: 69,
    question: '雲海酒造の黒麹仕込みのそば焼酎「吉兆雲海」にも使われている、独自開発の酵母「日向灘黒潮酵母」は、どこから採取されたものでしょう？',
    options: ['照葉樹林の土壌', '五ヶ瀬の清流', '日向灘の海水', '綾町の酒蔵'],
    correctAnswer: 2,
    explanation: '日向灘の海水から採取された酵母です。'
  },
  {
    id: 70,
    question: '2008年の全国酒類コンクールそば焼酎部門で1位を獲得した、雲海酒造のそば焼酎の銘柄は何でしょう？',
    options: ['雲海', '木挽BLUE', '吉兆雲海', '那由多の刻'],
    correctAnswer: 2,
    explanation: '「吉兆雲海」が全国酒類コンクールで1位を獲得しました。'
  },

  // セット8: 第4部 うまいもん編 + 第5部 ローカルCM編 (Q71-80)
  {
    id: 71,
    question: '宮崎の家庭の冷蔵庫には必ずあると言われるほど定番の「戸村の焼肉のタレ」。このタレが生まれたのはどこの市でしょう？',
    options: ['宮崎市', '都城市', '延岡市', '日南市'],
    correctAnswer: 3,
    explanation: '「戸村の焼肉のタレ」は日南市で生まれました。'
  },
  {
    id: 72,
    question: '「戸村の焼肉のタレ」は、もともとあるお店で肉の漬けだれとして使われていたものが商品化されました。そのお店の業種は何だったでしょう？',
    options: ['焼肉店', '居酒屋', '精肉店', 'スーパーマーケット'],
    correctAnswer: 2,
    explanation: '精肉店で使われていた漬けだれが商品化されました。'
  },
  {
    id: 73,
    question: '宮崎県農協果汁株式会社が製造・販売する、宮崎県民にとっておなじみのジュースブランドの愛称は何でしょう？',
    options: ['サンA', 'みやざき果汁', 'ひなたドリンク', '農協ジュース'],
    correctAnswer: 0,
    explanation: '「サンA」が宮崎県民にお馴染みのジュースブランドです。'
  },
  {
    id: 74,
    question: '宮崎牛が4大会連続で最高賞「内閣総理大臣賞」を受賞した、和牛のオリンピックとも呼ばれる大会の正式名称は何でしょう？',
    options: ['全国和牛選手権', '全国和牛能力共進会', '日本和牛グランプリ', '和牛マスターズ'],
    correctAnswer: 1,
    explanation: '正式名称は「全国和牛能力共進会」です。'
  },
  {
    id: 75,
    question: '「あんたどこ行きなさっと？」「わたしゃナガトモに行くとよ」というおばあちゃんの印象的なやりとりで知られるローカルCMは、何のお店のCMでしょう？',
    options: ['スーパーマーケット', '呉服店', 'ホームセンター', '仏壇店'],
    correctAnswer: 3,
    explanation: '仏壇店「ナガトモ」のCMです。'
  },
  {
    id: 76,
    question: '「お仏壇は森崎で～」というフレーズの後に、子供が言う決め台詞は何でしょう？',
    options: ['「おじいちゃんも言いよったわ～」', '「お母さん、したて言よるわ～」', '「うちも森崎にしよっと！」', '「やっぱり森崎やね～」'],
    correctAnswer: 1,
    explanation: '「お母さん、したて言よるわ～」が決め台詞です。'
  },
  {
    id: 77,
    question: '「太陽が呼んでる、サンサンサンAオレンジジュース」という歌詞が有名な「サンA」のCM。その最後のフレーズは何でしょう？',
    options: ['「おいしさ、宮崎から」', '「あなたの笑顔が見たいから」', '「自然の恵み、いただきます」', '「ひなたの国のジュースです」'],
    correctAnswer: 1,
    explanation: '「あなたの笑顔が見たいから」で締めくくられます。'
  },
  {
    id: 78,
    question: '宮崎の漬物メーカー「さとう漬物工業」のCMやパッケージに登場する、田舎の女の子をモチーフにしたオリジナルキャラクターの名前は何でしょう？',
    options: ['さとこちゃん', 'つけこちゃん', 'みきちゃん', 'ひなたちゃん'],
    correctAnswer: 2,
    explanation: 'オリジナルキャラクターは「みきちゃん」です。'
  },
  {
    id: 79,
    question: '「青島に来たら（来たら・来たら）パリパリパリパリ○○○○○」というCMソングで知られる宮崎の定番土産は何でしょう？',
    options: ['青島ういろう', '青島せんべい', '青島まんじゅう', '青島ラングドシャ'],
    correctAnswer: 1,
    explanation: '「青島せんべい」のCMソングです。'
  },
  {
    id: 80,
    question: '「ラブリー…モンドオル・モンドール、サガー」というアンニュイな女性ボーカルのCMで知られたお店は何でしょう？',
    options: ['ケーキのマエダ', '風月堂', 'モンドールサガ', 'スイートアリス'],
    correctAnswer: 2,
    explanation: '洋菓子店「モンドールサガ」のCMです。'
  },

  // セット9: 第5部 ローカルCM編 (Q81-90)
  {
    id: 81,
    question: '「ガぁスぅは都市ガス・み・や・ざ・き・ガス～う」という女性ボーカルのCMソングでおなじみの会社はどこでしょう？',
    options: ['宮崎ガス', '西部ガス', '九州ガス', '日向ガス'],
    correctAnswer: 0,
    explanation: '「宮崎ガス」のCMソングです。'
  },
  {
    id: 82,
    question: '2014年頃に「南ちゃん」が登場するストーリー仕立てのCMで大きな話題を呼んだ、宮崎県内の施設はどこでしょう？',
    options: ['フェニックス・シーガイア・リゾート', '青島リゾートこどものくに', '五ヶ瀬ハイランドスキー場', '宮崎市フェニックス自然動物園'],
    correctAnswer: 2,
    explanation: '「五ヶ瀬ハイランドスキー場」の「南ちゃん」CMが話題になりました。'
  },
  {
    id: 83,
    question: '「おててのしわとしわを合わせて…」というフレーズと、可愛らしい女の子の映像で全国的に有名なCM。宮崎県民にとっては、このCMはどこの仏壇店のイメージが強いでしょう？',
    options: ['はせがわ', 'ナガトモ', '森崎', '浜屋'],
    correctAnswer: 1,
    explanation: '宮崎では「ナガトモ」のイメージが強いです。'
  },
  {
    id: 84,
    question: '俳優の石田純一さんを起用し、「宮崎の夜は、俺にまかせろ」といったキャッチコピーで話題となったCMは、何の業種の会社のものでしょう？',
    options: ['焼肉店', '不動産会社', 'パチンコ店', '航空会社'],
    correctAnswer: 2,
    explanation: 'パチンコ店のCMでした。'
  },
  {
    id: 85,
    question: '吉田羊さんが出演するCMで「青いほう」として広く知られるようになった、雲海酒造の芋焼酎の銘柄は何でしょう？',
    options: ['さつま木挽', '日向木挽 黒', '木挽BLUE', '雲海'],
    correctAnswer: 2,
    explanation: '「木挽BLUE」が「青いほう」として有名になりました。'
  },
  {
    id: 86,
    question: '宮崎のご当地ヒーローで、児童虐待防止などの啓発CMにも出演しているのは誰でしょう？',
    options: ['フェニックスマン', 'ひなたライダー', '天尊降臨ヒムカイザー', 'マンゴー大王'],
    correctAnswer: 2,
    explanation: 'ご当地ヒーロー「天尊降臨ヒムカイザー」が啓発CMに出演しています。'
  },
  {
    id: 87,
    question: '以前、夕方のアニメ再放送枠などで頻繁に流れていた、地元の電気屋さんが家族総出で出演するような、写真1枚とナレーションで構成されたCMは何のCMだったでしょう？',
    options: ['ソニーショップ', 'パナソニックのお店', '日立チェーンストール', '東芝の店'],
    correctAnswer: 3,
    explanation: '「東芝の店」のCMが有名でした。'
  },
  {
    id: 88,
    question: '「あなたの笑顔が見たいから」というキャッチフレーズで締めくくられるCMは、どこの会社のものでしょう？',
    options: ['霧島酒造', '宮崎交通', '宮崎県農協果汁（サンA）', 'ハンズマン'],
    correctAnswer: 2,
    explanation: '「サンA」のキャッチフレーズです。'
  },
  {
    id: 89,
    question: '全国的には「サトウのごはん」で有名なサトウ食品ですが、宮崎県民にとって「さとうの」といえば、何の会社のイメージが強いでしょう？',
    options: ['さとうの梅干し', 'さとう漬物工業', 'さとう菓子店', 'さとう精肉店'],
    correctAnswer: 1,
    explanation: '宮崎では「さとう漬物工業」のイメージが強いです。'
  },
  {
    id: 90,
    question: '宮崎ケーブルテレビの公式YouTubeチャンネルで、過去のローカルCM集などが視聴できるサービスの名称は何でしょう？',
    options: ['MCN宮崎ケーブルテレビ[公式]', '宮崎CMアーカイブス', 'ひなたTV', 'てげテレCM館'],
    correctAnswer: 0,
    explanation: '「MCN宮崎ケーブルテレビ[公式]」でローカルCMが視聴できます。'
  },

  // セット10: 第5部 ローカルCM編 (Q91-100)
  {
    id: 91,
    question: '「おぐらのチキン南蛮」のCMで、「トンネルを抜けるとそこは○○の街だった」というフレーズがありました。○○に入る言葉は何でしょう？',
    options: ['南蛮', 'おぐら', '宮崎', '太陽'],
    correctAnswer: 1,
    explanation: '「おぐらの街」というフレーズでした。'
  },
  {
    id: 92,
    question: '宮崎山形屋のCMソングは、地元のギタリストなどがコピーするほど親しまれていました。この百貨店のキャッチフレーズとして使われていた言葉は何でしょう？',
    options: ['「暮らしの真ん中に。」', '「街のオアシス」', '「あなたの暮らしに寄り添う」', '「ふるさとのデパート」'],
    correctAnswer: 3,
    explanation: '「ふるさとのデパート」というキャッチフレーズでした。'
  },
  {
    id: 93,
    question: 'MRTラジオで長年放送されていた長寿番組で、そのテーマ曲が多くの宮崎県民の耳に残っている情報番組の名前は何でしょう？',
    options: ['MRTモーニングスペシャル', '暮らしのレーダー', '宮崎TODAY', 'サンシャインリクエスト'],
    correctAnswer: 1,
    explanation: '長寿番組「暮らしのレーダー」のテーマ曲が有名でした。'
  },
  {
    id: 94,
    question: 'UMKテレビ宮崎で放送されていた土曜日の人気番組で、そのテーマソングも有名だったのは何でしょう？',
    options: ['じゃがじゃがサタデー', 'さんさんサタデー', '土曜の夜はどようび！', 'UMKスーパーサタデー'],
    correctAnswer: 1,
    explanation: '「さんさんサタデー」が土曜日の人気番組でした。'
  },
  {
    id: 95,
    question: '宮崎の方言（西諸弁）をフランス語に聞かせたPR動画「ンダモシタン小林」で一躍有名になった市はどこでしょう？',
    options: ['都城市', 'えびの市', '小林市', '高原町'],
    correctAnswer: 2,
    explanation: '「小林市」のPR動画が話題になりました。'
  },
  {
    id: 96,
    question: '「おもちゃの○○○」という動かない静止画CMが懐かしいと感じる宮崎県民も多いでしょう。○○○に入る店名は何でしょう？',
    options: ['タナカ', 'イヌイ', 'サイトウ', 'スズキ'],
    correctAnswer: 1,
    explanation: '「おもちゃのイヌイ」のCMが懐かしいです。'
  },
  {
    id: 97,
    question: '宮崎太陽銀行のCM「サンライズ」篇が制作されたのはいつでしょう？',
    options: ['2010年', '2016年', '2018年', '2020年'],
    correctAnswer: 1,
    explanation: '2016年に制作されました。'
  },
  {
    id: 98,
    question: '全国的には「男梅」のCMで知られるノーベル製菓ですが、宮崎県民にとってノーベル製菓のCMといえば、どの商品のイメージが強いでしょう？',
    options: ['VC-3000のど飴', 'はちみつきんかんのど飴', 'のど黒飴', 'SOURS'],
    correctAnswer: 1,
    explanation: '宮崎では「はちみつきんかんのど飴」のCMが有名です。'
  },
  {
    id: 99,
    question: '「お仏壇のはせがわ」のCMに登場する女の子のイメージキャラクターの名前は何でしょう？',
    options: ['なむちゃん', 'しあわせ少女', 'のんのちゃん', 'てあわせ娘'],
    correctAnswer: 1,
    explanation: 'イメージキャラクターは「しあわせ少女」です。'
  },
  {
    id: 100,
    question: '多くのローカルCMが制作・放送されていますが、宮崎県内に存在する民放テレビ局は何局でしょう？',
    options: ['1局', '2局', '3局', '4局'],
    correctAnswer: 1,
    explanation: '宮崎県内の民放テレビ局は2局（MRT、UMK）です。'
  }
];
